module.exports = __webpack_public_path__ + "img/ChinaTelecom.b6c89acd.png";